import { PRINT_SET_PARAMS, PRINT_SET_PRINT_MODE, PRINT_SET_TABLE_MODE } from './types';

export const mutations = {
  [PRINT_SET_PARAMS]: (state, payload) => {
    state.printParams = payload;
  },
  [PRINT_SET_PRINT_MODE]: (state, payload) => {
    state.printMode = payload;
  },
  [PRINT_SET_TABLE_MODE]: (state, payload) => {
    state.tableMode = payload;
  }
};
